import axios from "axios";
import { backendUrl, frontendURL } from "../config/settings-network.mjs";
import { Buffer } from "buffer";

// Crée une instance Axios avec la configuration de base
const http = axios.create({
  baseURL: backendUrl,
  headers: {
    "Content-type": "application/json",
    "x-access-token": "", //le x-access-token  token doit être ajouté automatiquement par le middlewae vuex : voir les mutators de vueX ex : state.accessToken = token;
  },
});

//TOKEN MANAGEMENT
function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    Buffer.from(base64, "base64")
      .toString("ascii")
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

export function isTokenValid() {
  if (localStorage.getItem("user")) {
    const accessToken = JSON.parse(localStorage.getItem("user")).accessToken;
    const jwtPayload = parseJwt(accessToken);

    if (jwtPayload.exp < Date.now() / 1000) {
      return false; // Token expiré
    }
  }
  return true; // Token valide
}

// ─── Auto-logout timer ──────────────────────────────────────────────────────
// Planifie une déconnexion automatique à l'expiration exacte du JWT.
// À appeler après chaque login et au chargement de la page.
let _autoLogoutTimer = null;

export function scheduleAutoLogout() {
  clearTimeout(_autoLogoutTimer);
  _autoLogoutTimer = null;

  const userStr = localStorage.getItem("user");
  if (!userStr) return;

  try {
    const accessToken = JSON.parse(userStr).accessToken;
    const jwtPayload = parseJwt(accessToken);
    const delay = jwtPayload.exp * 1000 - Date.now();
    if (delay <= 0) return; // déjà expiré — router.beforeEach gère la redirection

    _autoLogoutTimer = setTimeout(() => {
      localStorage.removeItem("user");
      const url = new URL(`${frontendURL}/logout`);
      url.searchParams.append("messageCode", 1);
      window.location.replace(url.toString());
    }, delay);
  } catch {
    // token malformé → on ignore, l'intercepteur Axios prendra le relais
  }
}

export function clearAutoLogout() {
  clearTimeout(_autoLogoutTimer);
  _autoLogoutTimer = null;
}

export default http;
